import React, { useEffect, useState } from "react";
import theme from "../../Styles/theme";
import Modal from "react-modal";
import {
  Button,
  Container,
  HandleButton,
  HandleInput,
  Input,
  Title,
} from "./styles";
import { ModalDivX } from "../ModalDivX";
import { useCartorio } from "../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../Hooks/funcionarioCartorio";
import { IOperacao, useOperacao } from "../../Hooks/operacoes";
import api from "../../Services/api";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";
import { ICartorios } from "../../Pages/Cartorio_Pages/App_Pages/Cartorios";
import { usePrefeitura } from "../../Hooks/usePrefeitura";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  cartorio_relacao: ICartorios;
}

export function EditarRelacoesPref_Cart({
  open,
  onClose,
  cartorio_relacao,
}: Props) {
  const { prefeituraIsLogged,checarTokenPrefeitura } = usePrefeitura();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  function handleClose() {
    onClose();
  }

  async function confirmar() {
  
    try {
      setLoading(true);
      if(prefeituraIsLogged){
        await checarTokenPrefeitura();
      }

      await api.put(`/ligacao/`,{
        PREFEITURA_ID:cartorio_relacao.PREFEITURA_ID,
        STATUS:'A',
        CARTORIO_ID:cartorio_relacao.CARTORIO_ID,
        ID:cartorio_relacao.ID
      })
      cartorio_relacao.STATUS = 'A';
      onClose()
    } catch (error) {
     setError({ title: "Ocorreu um erro ao tentar rejeitar a solicitação!", message: "Não foi possível rejeitar a solicitação!"})
      
    }finally{
      setLoading(false);
    }

  }

  async function rejeitar() {
    
    try {
      setLoading(true);
      if(prefeituraIsLogged){
        await checarTokenPrefeitura();
      }

      await api.delete(`/ligacao/${cartorio_relacao.ID}`)
      cartorio_relacao.REJEITADO = true;
      onClose()
    } catch (error) {
     setError({ title: "Ocorreu um erro ao tentar rejeitar a solicitação!", message: "Não foi possível rejeitar a solicitação!"})
      
    }finally{
      setLoading(false);
    }

  }

  useEffect(() => {}, [cartorio_relacao.ID]);

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <ModalDivX execute={handleClose} />
        {cartorio_relacao.ID ? (
          <>
            {" "}
            {cartorio_relacao.STATUS.trim() == "A" ? (
              <>
                <Title>
                  Você já possui uma ligação com {cartorio_relacao.NOME}
                </Title>
              </>
            ) : (
              <>
                <>
                  <Title>
                    {cartorio_relacao.NOME} seja enviar imovéis para você!
                  </Title>
                  <HandleButton>
                    <Button onClick={rejeitar}>Rejeitar</Button>
                    <Button onClick={confirmar}>Confimar</Button>
                  </HandleButton>
                </>
              </>
            )}
          </>
        ) : (
          ""
        )}
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => {
          setError({ title: "", message: "" });
        }}
      />
    </Modal>
  );
}
